import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyBootModule } from "owa-bundling-light";

const lazyModule: LazyBootModule<typeof lazyIndex> = new LazyBootModule<typeof lazyIndex>(() => import(/* webpackChunkName: "TeamsPalette" */ "./lazyIndex"), { name: "TeamsPalette" });

export const lazyGetTeamsPalette: LazyAction<typeof lazyIndex.getTeamsPalette, typeof lazyModule> = new LazyAction(lazyModule, m => m.getTeamsPalette);
export const lazyGetTeamsBrandVariants: LazyAction<typeof lazyIndex.getTeamsBrandVariants, typeof lazyModule> = new LazyAction(lazyModule, m => m.getTeamsBrandVariants);
